module.exports = __webpack_public_path__ + "static/img/公司17.f3e22dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司17.jpg
// module id = I2Ln
// module chunks = 1